import React from "react";
import { Navigate } from "react-router-dom";
import { getToken } from "../AuthMiddleware/TokenService";

const isAuthenticated = () => {
  const token = getToken();

  return token !== null && token !== undefined;
};

const ProtectedRoute = ({ element }) => {
  return isAuthenticated() ? element : <Navigate to="/auth/login" replace />;
};

export default ProtectedRoute;
